<template>
  <div class="mesh-details__wrapper" v-if="mesh && mesh.userData">
    <ol class="mesh-details__list">
      <li v-if="mesh.userData.fabric" class="mesh-deatils__list-item mesh-deatils__list-item--material">
        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"></path></svg>
        {{ mesh.userData.fabric.name || 'Material' }}</li>
      <!--if texture-->
      <li v-if="hasTexture" class="mesh-deatils__list-item mesh-deatils__list-item--texture">
        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"></path></svg>
        {{ textureTitle }}
        <div class="texture-settings__wrapper" v-if="mesh.material.userData.uniforms">

          <ul class="texture-settings__list">
            <li class="texture-settings__list-item texture-settings__list-item--rotation">{{ mesh.material.userData.uniforms.tRotation.value.toFixed(0) }}°</li><!--rotation-->
            <li class="texture-settings__list-item texture-settings__list-item--scale">{{ mesh.material.userData.uniforms.tScale.value.toFixed(1) }}x</li><!--scale-->
            <li class="texture-settings__list-item texture-settings__list-item--offset-x">{{ mesh.material.userData.uniforms.tOffsetX.value.toFixed(1) }}u</li><!--offset x-->
            <li class="texture-settings__list-item texture-settings__list-item--offset-y">{{ mesh.material.userData.uniforms.tOffsetY.value.toFixed(1) }}v</li><!--offset y-->
          </ul>
        </div>
      </li>
      <!--else color-->
      <li v-else class="mesh-deatils__list-item mesh-deatils__list-item--color">
        <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"></path></svg>
        Color: <span class="mesh-details__color-badge" :style="{ backgroundColor: '#'+mesh.material.color.getHexString()}"></span> {{ '#'+mesh.material.color.getHexString() }}
      </li>
      <!--end if texture-->
    </ol>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

  export default {
    name: "MeshSelectorMeshDetails",
    props: {
      mesh: {
        type: Object,
        required: true,
      }
    },
    data() {
      return {
        hasTexture: false,
      }
    },
    watch: {
      // mesh: function() {
      //   console.log(this.mesh);
      // },
      selectedTexture: function(val) {
        if(this.selectedMesh === this.mesh)
          this.hasTexture = val ? true : false;
      }
    },
    filters: {
      fixed: function(number) {

        if(!( typeof number === 'number')) {
          return '';
        }

        return number.toFixed(2);

      }
    },
    computed: {
      ...mapGetters('textures',[
        'selectedTexture',
        'selectedColor',
        'colors',
      ]),
      ...mapGetters('clothes',[
        'selectedMesh',
      ]),
      textureTitle: function() {
        return this.mesh.material.userData.texture ?  this.mesh.material.userData.texture.title : '';
      }
      // hasTexture: function() {
      //   return this.mesh.material.userData?.texture;
      // }
    },
    // mounted() {
    //   console.log(this.mesh);
    // }
  }
</script>

<style scoped>

  .mesh-details__wrapper {
    padding: 10px 0;
  }

  .mesh-deatils__list-item svg {
    display: inline-block;
    margin-right: 5px;
    transform-origin: center;
    transform: rotate(180deg);
    /*color: black;*/
  }

  .mesh-details__list {
    padding-left: 10px;
  }

  .texture-settings__list {
    padding-left: 20px;
  }

  .mesh-deatils__list-item, .texture-settings__list-item {
    font-size: 12px;
    text-transform: uppercase;
  }

  .texture-settings__list-item {
    text-transform: lowercase;
  }

  .texture-settings__list-item {
    display: inline-block;
    margin-right: 15px;
    font-style: italic;
  }

  .texture-settings__list-item:last-child {
    margin-right: 0;
  }

  .mesh-details__color-badge {
    display: inline-block;
    height: 18px;
    width: 18px;
    border-radius: 50%;
    margin-left: 10px;
    border: 1px solid #333333;
    margin-right: 5px;
    transform: translateY(4px);
  }
</style>